import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from '../../../contract/base/Response';
import { AddressDetail } from '../../../contract/common/AddressDetail';
import { getSelfAddress } from '../../../services/identity/user/getSelfAddress';
import { dispatch } from '../../store';

type State = {
  isLoading: boolean;
  errors: ApiError[] | null;
  address: AddressDetail | null;
};

const initialState: State = {
  isLoading: false,
  errors: null,
  address: null,
};

const slice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasErrors(state, action: PayloadAction<ApiError[]>) {
      state.isLoading = false;
      state.errors = action.payload;
    },

    // GET CUSTOM FILES
    getAddressSuccess(state, action: PayloadAction<{ address: AddressDetail; }>) {
      state.isLoading = false;
      state.address = action.payload.address;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
} = slice.actions;

export function getUserAddress() {
  return async () => {
    dispatch(slice.actions.startLoading());

    const response = await getSelfAddress();

    if (response.success) {
      dispatch(slice.actions.getAddressSuccess({
        address: response.data,
      }));
    }
    else {
      dispatch(slice.actions.hasErrors(response.errors));
    }
  };
}